import { Link } from 'react-router';

import { ROUTES } from '#/config/routes';
import { Button } from '#/modules/commonComponents/button';
import { entityStatusSideMsgValue } from '#/modules/commonComponents/table/entityStatusIconHelpers';

function dash(value) {
  if (value === null || value === undefined || value === '') {
    return '-';
  }
  return value;
}

/** Block A：僅狀態 */
export const supplierSideMsgStatusBlock = {
  fields: [
    {
      key: 'status',
      label: '狀態',
      render: (row) => (
        <div className="side_msg-row">
          <h3>狀態</h3>
          {entityStatusSideMsgValue(row)}
        </div>
      ),
    },
  ],
};

/** Block B：操作（緊接狀態後；本輪僅編輯） */
export function buildSupplierSideMsgActionsBlock({ canUpdate = true } = {}) {
  return {
    condition: (row) => canUpdate && Boolean(row?.id),
    fields: [
      {
        key: 'actions',
        label: '操作',
        render: (row) => (
          <div className="side_msg-row">
            <h3>操作</h3>
            <div className="flex flex-wrap items-center gap-2">
              <Button type="button" variant="outline" asChild>
                <Link to={ROUTES.supplierEdit(row.id)}>編輯</Link>
              </Button>
            </div>
          </div>
        ),
      },
    ],
  };
}

export const supplierSideMsgActionsBlock = buildSupplierSideMsgActionsBlock();

/** Block C：主檔摘要 */
export const supplierSideMsgDetailBlock = {
  fields: [
    { label: '代號', value: 'code' },
    { label: '名稱', value: 'name' },
    { label: '中文名', value: (row) => dash(row?.chineseName) },
    { label: '統編', value: (row) => dash(row?.taxIdNumber) },
    { label: '電話', value: (row) => dash(row?.phone) },
    { label: '備註', value: (row) => dash(row?.remark) },
  ],
};

/** 列表 SideMsg：狀態 → 操作 → 明細 */
export function buildSupplierSideMsgBlocks({ canUpdate = true } = {}) {
  return [
    supplierSideMsgStatusBlock,
    buildSupplierSideMsgActionsBlock({ canUpdate }),
    supplierSideMsgDetailBlock,
  ];
}

export const supplierSideMsgBlocks = buildSupplierSideMsgBlocks();
